
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DialogBanner from "@/components/app/DialogBanner.vue";
import Booking from "@/domain/booking/Booking";
import TimeService from "@/services/TimeService";
import CreateBookingFromWaitingList from "@/components/booking/waitingList/CreateBookingFromWaitingList.vue";
import Room from "@/domain/restaurant/Room";
import UtilService from "@/services/UtilService";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
import RemoteServices from "@/services/RemoteServices";
import NextButton from "@/components/app/NextButton.vue";
import BookingOverviewComponent from "@/components/booking/components/BookingOverviewComponent.vue";
@Component({
  components: {
    NextButton,
    ConfirmationDialog,
    CreateBookingFromWaitingList,
    DialogBanner,
    BookingOverviewComponent
  }
})
export default class WaitingListDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: () => [] })
  allBookings!: Booking[];

  selectedBooking: Booking | null = null;

  currentTab = 0;

  rooms: { [key: number]: Room } = {};

  loading = false;

  get bookingsOnWaitingList() {
    return this.allBookings.filter(b => b.isOnWaitingList());
  }

  get confirmationDialog() {
    return this.$refs.confirmationDialog as ConfirmationDialog;
  }

  @Watch("value")
  async getRoomDictionary() {
    if (this.value)
      this.rooms = UtilService.getRoomDict(
        await this.$store.getters.getSelectedRestaurant
      );
  }

  getRoomNameFromId(id: number): string {
    if (this.rooms[id] != null) return this.rooms[id].roomName;
    return "";
  }

  headers = [
    {
      text: this.$t("booking.creationDate.label"),
      value: "creationDate",
      groupable: false,
      width: 150,
      sortable: false
    },
    {
      text: this.$t("booking.time"),
      value: "bookingDateTime",
      groupable: false,
      sortable: false,
      width: 100
    },
    {
      text: this.$t("booking.numberOfPeople"),
      value: "numberOfPeople",
      groupable: false,
      sortable: false
    },
    {
      text: this.$t("booking.customerName"),
      value: "customerName",
      groupable: false,
      sortable: false
    },

    {
      text: this.$t("booking.preferredRoom"),
      value: "preferredRoomId",
      groupable: false,
      sortable: false
    },

    {
      text: this.$t("booking.notes.label"),
      value: "notes",
      groupable: false,
      sortable: false
    },
    {
      text: "",
      value: "data-table-expand",
      groupable: false,
      width: 0,
      sortable: false
    }
  ];

  get dialog() {
    return this.value;
  }

  set dialog(newValue) {
    this.$emit("input", newValue);
    this.currentTab = 0;
    this.selectedBooking = null;
  }

  getDateTimeDisplayString(dateTimeString: string) {
    return TimeService.getDateTimeDisplayStringFromISO(dateTimeString);
  }

  async cancelBooking(booking: Booking) {
    if (
      await this.confirmationDialog.open(
        this.$tc("booking.waitingList.cancel.label"),
        this.$tc("booking.waitingList.cancel.message")
      )
    ) {
      try {
        this.loading = true;
        await RemoteServices.updateBookingStatus(
          booking.bookingId,
          "CANCELLED",
          null
        );
        await this.$store.dispatch(
          "success",
          this.$t("booking.waitingList.cancel.success")
        );
        this.$emit("update-booking", booking);
        this.dialog = false;
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.loading = false;
    }
  }

  selectBooking(booking: Booking) {
    this.selectedBooking = booking;
    this.currentTab = 1;
  }

  goBack() {
    if (this.loading) return;
    if (this.currentTab === 0) this.dialog = false;
    else this.currentTab -= 1;
  }

  emitUpdated(updated: Booking) {
    this.$emit("update-booking", updated);
    this.dialog = false;
  }
}
